interface Props {
  value: string
}

export const TextAreaView = ({ value }: Props) => {
  return <div className="whitespace-normal">{value}</div>
}
